import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import categoryReducer from "./slices/categorySlice";
import productReducer from "./slices/productSlice";
import vendorReducer from "./slices/vendorSlice";
import designReducer from "./slices/designSlice";
import purityReducer from "./slices/puritySlice";
import branchReducer from "./slices/branchSlice";
import counterReducer from "./slices/counterSlice";
import customerReducer from "./slices/customerSlice";
import stockReducer from "./slices/labelledStockSlice";
import unlabelledStockReducer from "./slices/unlabelledStockSlice";
import notificationsReducer from "./slices/notificationsSlice";
import globalVariableReducer from "./slices/globalVariableSlice";
import diamondSieveReducer from "./slices/diamondSieveSlice";
import diamondSizeReducer from "./slices/diamondSizeSlice";
import latestRateReducer from "./slices/latestRateSlice";

import stoneReducer from "./slices/stoneSlice";
import diamondReducer from "./slices/diamondSlice";
import stoneAttrReducer from "./slices/stoneAttrSlice";
import invoiceTemplateApi from "./toolkitServices/invoiceTemplateApi";

import userApi from "./toolkitServices/userApi";
import cashFlowApi from "./toolkitServices/cashFlowApi";
import rateApi from "./toolkitServices/rateApi";
import companyApi from "./toolkitServices/companyApi";
import estimateApi from "./toolkitServices/estimateApi";
import otherSettingsApi from "./toolkitServices/otherSettingsApi";
import roleApi from "./toolkitServices/roleApi";
import departmentApi from "./toolkitServices/departmentApi";
import bankApi from "./toolkitServices/bankApi";
import urdApi from "./toolkitServices/urdApi";
import branchApi from "./toolkitServices/branchApi";
import whatsappApi from "./toolkitServices/whatsappApi";
import categoryApi from "./toolkitServices/categoryApi";
import rfidMasterApi from "./toolkitServices/rfidMasterApi";
import productApi from "./toolkitServices/productApi";
import userPermissionApi from "./toolkitServices/userPermissionApi";
import enquiryApi from "./toolkitServices/enquiryServiceApi";
import vendorApi from "./toolkitServices/vendorApi";
import designApi from "./toolkitServices/designApi";
import purityApi from "./toolkitServices/purityApi";
import stockApi from "./toolkitServices/stockApi";
import adminTenantApi from "./toolkitServices/adminTenantApi";
import stoneApi from "./toolkitServices/stoneApi";
import transferApi from "./toolkitServices/transferApi";
import diamondApi from "./toolkitServices/diamondApi";
import reportApi from "./toolkitServices/reportApi";
import employeeApi from "./toolkitServices/employeeApi";
import diamondSieveApi from "./toolkitServices/diamondSieveApi";
import diamondSizeApi from "./toolkitServices/diamondSizeApi";
import invoiceApi from "./toolkitServices/invoiceApi";
import quotationApi from "./toolkitServices/quotationApi";
import unlabelledApi from "./toolkitServices/unlabelledApi";
import notificationsApi from "./toolkitServices/notificationsApi";
import labelTemplateApi from "./toolkitServices/labelTemplateApi";
import customerApi from "./toolkitServices/customerApi";
import counterApi from "./toolkitServices/counterApi";
import looseDiamondApi from "./toolkitServices/looseDiamondApi";
import customerTransactionApi from "./toolkitServices/customerTransactionApi";
import salesReturnApi from "./toolkitServices/salesReturnApi";
import dashboardApi from "./toolkitServices/dashboardApi";
import goldSchemeApi from "./toolkitServices/goldSchemeApi";
import securityPinApi from "./toolkitServices/securityPinApi";
import moduleFieldsApi from "./toolkitServices/moduleFieldsApi";
import dailyMessageApi from "./toolkitServices/dailyMessageApi";
import { looseStoneApi } from "./toolkitServices/looseStoneApi";
import { stoneAttributeApi } from "./toolkitServices/stoneAttributeApi";
import { diamondAttributeApi } from "./toolkitServices/diamondAttributeApi";

const store = configureStore({
  reducer: {
    [userApi.reducerPath]: userApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [departmentApi.reducerPath]: departmentApi.reducer,
    [bankApi.reducerPath]: bankApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [designApi.reducerPath]: designApi.reducer,
    [purityApi.reducerPath]: purityApi.reducer,
    [stockApi.reducerPath]: stockApi.reducer,
    [stoneApi.reducerPath]: stoneApi.reducer,
    [diamondApi.reducerPath]: diamondApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [unlabelledApi.reducerPath]: unlabelledApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    [enquiryApi.reducerPath]: enquiryApi.reducer,
    [stoneAttributeApi.reducerPath]: stoneAttributeApi.reducer,
    [whatsappApi.reducerPath]: whatsappApi.reducer,
    [diamondAttributeApi.reducerPath]: diamondAttributeApi.reducer,
    [looseStoneApi.reducerPath]: looseStoneApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [rfidMasterApi.reducerPath]: rfidMasterApi.reducer,
    [urdApi.reducerPath]: urdApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [quotationApi.reducerPath]: quotationApi.reducer,
    [counterApi.reducerPath]: counterApi.reducer,
    [diamondSieveApi.reducerPath]: diamondSieveApi.reducer,
    [diamondSizeApi.reducerPath]: diamondSizeApi.reducer,
    [looseDiamondApi.reducerPath]: looseDiamondApi.reducer,
    [customerTransactionApi.reducerPath]: customerTransactionApi.reducer,
    [transferApi.reducerPath]: transferApi.reducer,
    [otherSettingsApi.reducerPath]: otherSettingsApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [rateApi.reducerPath]: rateApi.reducer,
    [labelTemplateApi.reducerPath]: labelTemplateApi.reducer,
    [userPermissionApi.reducerPath]: userPermissionApi.reducer,
    [salesReturnApi.reducerPath]: salesReturnApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [moduleFieldsApi.reducerPath]: moduleFieldsApi.reducer,
    [goldSchemeApi.reducerPath]: goldSchemeApi.reducer,
    [estimateApi.reducerPath]: estimateApi.reducer,
    [securityPinApi.reducerPath]: securityPinApi.reducer,
    [invoiceTemplateApi.reducerPath]: invoiceTemplateApi.reducer,
    [cashFlowApi.reducerPath]: cashFlowApi.reducer,
    [adminTenantApi.reducerPath]: adminTenantApi.reducer,
    [dailyMessageApi.reducerPath]: dailyMessageApi.reducer,
    auth: authReducer,
    categories: categoryReducer,
    products: productReducer,
    vendors: vendorReducer,
    designs: designReducer,
    purities: purityReducer,
    branches: branchReducer,
    labelledStocks: stockReducer,
    unlabelledStocks: unlabelledStockReducer,
    stones: stoneReducer,
    stoneAttr: stoneAttrReducer,
    notifications: notificationsReducer,
    globalVariables: globalVariableReducer,
    counters: counterReducer,
    diamonds: diamondReducer,
    diamondSieves: diamondSieveReducer,
    diamondSizes: diamondSizeReducer,
    lastestRates: latestRateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userApi.middleware)
      .concat(companyApi.middleware)
      .concat(departmentApi.middleware)
      .concat(bankApi.middleware)
      .concat(branchApi.middleware)
      .concat(categoryApi.middleware)
      .concat(otherSettingsApi.middleware)
      .concat(productApi.middleware)
      .concat(vendorApi.middleware)
      .concat(designApi.middleware)
      .concat(purityApi.middleware)
      .concat(stockApi.middleware)
      .concat(stoneApi.middleware)
      .concat(diamondApi.middleware)
      .concat(enquiryApi.middleware)
      .concat(whatsappApi.middleware)
      .concat(adminTenantApi.middleware)
      .concat(reportApi.middleware)
      .concat(rfidMasterApi.middleware)
      .concat(unlabelledApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(employeeApi.middleware)
      .concat(stoneAttributeApi.middleware)
      .concat(diamondAttributeApi.middleware)
      .concat(cashFlowApi.middleware)
      .concat(diamondSieveApi.middleware)
      .concat(diamondSizeApi.middleware)
      .concat(looseStoneApi.middleware)
      .concat(customerTransactionApi.middleware)
      .concat(customerApi.middleware)
      .concat(urdApi.middleware)
      .concat(invoiceApi.middleware)
      .concat(quotationApi.middleware)
      .concat(counterApi.middleware)
      .concat(looseDiamondApi.middleware)
      .concat(transferApi.middleware)
      .concat(roleApi.middleware)
      .concat(rateApi.middleware)
      .concat(labelTemplateApi.middleware)
      .concat(userPermissionApi.middleware)
      .concat(salesReturnApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(goldSchemeApi.middleware)
      .concat(estimateApi.middleware)
      .concat(securityPinApi.middleware)
      .concat(moduleFieldsApi.middleware)
      .concat(invoiceTemplateApi.middleware)
      .concat(dailyMessageApi.middleware),
});

export default store;
